module.exports = __webpack_public_path__ + "img/smNew.b9438cda.svg";